import React from 'react'

export const COUNTRY_CODES = [
  { code: "+91", country: "IN", flag: "🇮🇳", name: "India" },
  { code: "+1", country: "US", flag: "🇺🇸", name: "United States" },
  { code: "+44", country: "GB", flag: "🇬🇧", name: "United Kingdom" },
]; 


export const createSearchDebounce = (callback) => {
  const timer = setTimeout(callback, 500);
  return () => clearTimeout(timer);
};


export const debounceFunction = (fn, delay = 300) => {
  let timerId;

  const debouncedFn = (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      fn(...args);
    }, delay);
  };

  return debouncedFn;
};

export const downloadExcelFile = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileName}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const calculateTotalLearners = (content = []) =>
  content.reduce((acc, item) => {
    if (item.type === "GROUP") return acc + (item.totalLearners || 0);
    return acc + 1;
  }, 0);